module.exports = __webpack_public_path__ + "img/tramites.b692fa75.jpg";